import { getDataItem, getDataList, getError, getId, getIsLoading, getSuccess, getTotal } from "@/store/Crud/functions/getters";
export const getSelectedTheoryStudentEducation = (state) => state.selectedTheoryStudentEducation;
export const getSelectedPreExamStudentEducation = (state) => state.selectedPreExamStudentEducation;
export const getSelectedAccountStudentEducation = (state) => state.selectedAccountStudentEducation;
export const getSelectedPlaygroundStudentEducation = (state) => state.selectedPlaygroundStudentEducation;
export const getLearningMode = (state) => state.learningMode;
export default {
    getError,
    getIsLoading,
    getDataItem,
    getSuccess,
    getDataList,
    getTotal,
    getId,
    getSelectedTheoryStudentEducation,
    getSelectedPreExamStudentEducation,
    getSelectedAccountStudentEducation,
    getSelectedPlaygroundStudentEducation,
    getLearningMode,
};
